import { Presence } from "revolt-api/src";

export const DEFAULT_PRESENCE: Presence = "Online";

export type AfkPresenceDecision = {
    /** Presence to send, or null when the user should be left alone. */
    presence: Presence | null;

    /**
     * Presence to remember as the pre-AFK value, or undefined when a value is
     * already remembered and must not be overwritten.
     */
    save?: Presence;
};

/**
 * Decide what presence to send when the platform reports the user away or back.
 *
 * @param isAfk   whether the platform currently reports the user as away
 * @param current presence the user is currently shown with, if any
 * @param saved   presence remembered on the way into AFK, if any
 * @returns what to send and what to remember
 */
export function nextAfkPresence(
    isAfk: boolean,
    current: Presence | null | undefined,
    saved: Presence | null | undefined,
): AfkPresenceDecision {
    if (isAfk) {
        return {
            presence: "Idle",
            save:
                saved === undefined || saved === null
                    ? (current ?? DEFAULT_PRESENCE)
                    : undefined,
        };
    }

    if (saved !== undefined && saved !== null) {
        return { presence: saved };
    }

    if (current === "Idle") {
        return { presence: DEFAULT_PRESENCE };
    }

    return { presence: null };
}
